import React, { Component } from "react";
import { ButtonGroup, Button } from "reactstrap";
import { connect } from "react-redux";
import ReactTable from "react-table";
import "react-table/react-table.css";
import * as actions from "../../actions";
import { reservationsDataColumns } from "./Components/dataColumns";
import RoomModal from "./Components/RoomsModal";
import MembersModal from "./Components/MembersModal";
import BulkChangeModal from "./Components/BulkChangeModal";
import DeleteReservationModal from "./Components/DeleteReservationModal";
import "./Reservations.css";

class Reservations extends Component {
  componentDidMount() {
    this.props.getVenues("venuesLookup", 1, { page_size: 9999, filters: [{ filter_column: "efficiency_enabled", filter_value: "1" }] });
    this.props.getHotels("hotelsLookup", 1, { page_size: 9999 });
  }
  openSchedule = reservationOrIndex => {
    const reservationRows =
      this.props.reservationReducer.reservations &&
      this.props.reservationReducer.reservations.data
        ? this.props.reservationReducer.reservations.data
        : [];
    const reservationIndex =
      typeof reservationOrIndex === "number"
        ? reservationOrIndex
        : reservationRows.findIndex(
            reservation =>
              reservation &&
              (reservation === reservationOrIndex ||
                String(reservation.id) === String(reservationOrIndex.id))
          );
    const reservation = reservationRows[reservationIndex];
    this.props.openReservationSchedule(reservation, this.props.history, reservationIndex);
  };
  openMembersList = reservationOrIndex => {
    const reservationRows =
      this.props.reservationReducer.reservations &&
      this.props.reservationReducer.reservations.data
        ? this.props.reservationReducer.reservations.data
        : [];
    const reservationIndex =
      typeof reservationOrIndex === "number"
        ? reservationOrIndex
        : reservationRows.findIndex(
            reservation =>
              reservation &&
              (reservation === reservationOrIndex ||
                String(reservation.id) === String(reservationOrIndex.id))
          );
    this.props.updateReservationProps([{ prop: "reservationIndex", value: reservationIndex }, { prop: "isMemberModalOpen", value: true }]);
  };
  openChangePage = () => {
    this.props.openBulkReservationSchedule(
      this.props.reservationReducer.fromDate,
      this.props.reservationReducer.toDate,
      this.props.history
    );
  };
  deleteReservation = reservationOrIndex => {
    const reservationRows =
      this.props.reservationReducer.reservations &&
      this.props.reservationReducer.reservations.data
        ? this.props.reservationReducer.reservations.data
        : [];
    const index =
      typeof reservationOrIndex === "number"
        ? reservationOrIndex
        : reservationRows.findIndex(
            reservation =>
              reservation &&
              (reservation === reservationOrIndex ||
                String(reservation.id) === String(reservationOrIndex.id))
          );
    this.props.updateReservationProps([
      { prop: "deleteReservationIndex", value: index },
      { prop: "isDeleteReservationModalOpen", value: true }
    ]);
  };
  getReservationRooms = reservationOrIndex => {
    const reservationRows =
      this.props.reservationReducer.reservations &&
      this.props.reservationReducer.reservations.data
        ? this.props.reservationReducer.reservations.data
        : [];
    const reservationIndex =
      typeof reservationOrIndex === "number"
        ? reservationOrIndex
        : reservationRows.findIndex(
            reservation =>
              reservation &&
              (reservation === reservationOrIndex ||
                String(reservation.id) === String(reservationOrIndex.id))
          );
    const reservation = reservationRows[reservationIndex];

    if (reservation) {
      this.props.getResevationRooms(reservation.id, reservationIndex);
    }
  };
  confirmDeleteReservation = () => {
    const { deleteReservationIndex, reservations } = this.props.reservationReducer;
    const reservationRows = reservations && reservations.data ? reservations.data : [];
    const reservation =
      deleteReservationIndex !== null ? reservationRows[deleteReservationIndex] : null;

    if (reservation) {
      this.props.deleteReservation(reservation, deleteReservationIndex);
    }

    this.props.updateReservationProps([
      { prop: "deleteReservationIndex", value: null },
      { prop: "isDeleteReservationModalOpen", value: false }
    ]);
  };
  submitRooms = reservationRooms => {
    this.props.submitRooms(reservationRooms);
  };
  deleteRoom = index => {
    let resroom = this.props.reservationReducer.reservationRooms.data[index];
    if (resroom.hasOwnProperty("id")) {
      this.props.deleteRoom(index, resroom);
    } else {
      this.props.deleteReservationProps([{ prop: "reservationRooms.data." + index }]);
    }
  };

  paginate = (tableState, tableInstance) => {
    let param = {};
    if (tableState.sorted.length !== 0) {
      param.sort_column = tableState.sorted[0].id;
      param.sort_type = tableState.sorted[0].desc ? "desc" : "asc";
    }
    if (tableState.filtered.length !== 0) {
      param.filters = [];
      for (let i = 0; i < tableState.filtered.length; i++) {
        // tableState.filtered[i].id
        param.filters.push({ filter_column: tableState.filtered[i].id, filter_value: tableState.filtered[i].value });
      }
    }
    param.page_size = tableState.pageSize;
    this.props.getReservations("reservations", tableState.page + 1, param);
  };
  render() {
    const {
      reservations,
      isRoomModalOpen,
      reservationRooms,
      roomModalReservationId,
      isRoomSaving,
      isMemberModalOpen,
      reservationIndex,
      isDeleteReservationModalOpen,
      deleteReservationIndex,
      isResLoading,
      isBulkOpen,
      fromDate,
      toDate
    } = this.props.reservationReducer;
    const { hotelsLookup } = this.props.hotelsReducer;
    const { last_page } = reservations;
    const reservationRows = reservations && reservations.data ? reservations.data : [];
    const deleteReservationRecord =
      deleteReservationIndex !== null ? reservationRows[deleteReservationIndex] : null;
    let res;
    reservationIndex !== null && reservationRows[reservationIndex]
      ? (res = reservationRows[reservationIndex])
      : (res = {});

    const averageEfficiency =
      reservationRows.length > 0
        ? Math.round(
            reservationRows.reduce((sum, row) => sum + (parseFloat(row.efficiency) || 0), 0) /
              reservationRows.length
          )
        : 0;

    return (
      <div className="reservations-page">
        <div className="reservations-page__hero">
          <div>
            <div className="reservations-page__eyebrow">Operations</div>
            <h1 className="reservations-page__title">Reservations</h1>
            <p className="reservations-page__copy">
              Review arrivals and departures, monitor schedule efficiency, and open the
              key reservation flows from one workspace.
            </p>
          </div>

          <div className="reservations-page__stats">
            <div className="reservations-stat">
              <span className="reservations-stat__value">{reservationRows.length}</span>
              <span className="reservations-stat__label">Visible reservations</span>
            </div>
            <div className="reservations-stat">
              <span className="reservations-stat__value">{averageEfficiency}%</span>
              <span className="reservations-stat__label">Average efficiency</span>
            </div>
            <div className="reservations-stat">
              <span className="reservations-stat__value">
                {isResLoading ? "Syncing" : "Ready"}
              </span>
              <span className="reservations-stat__label">Data state</span>
            </div>
          </div>
        </div>

        <div className="reservations-toolbar">
          <div className="reservations-toolbar__group">
            <ButtonGroup>
              <Button onClick={() => this.props.getReservations("reservations", 1, {})} color="faiz1">
                Refresh
              </Button>
            </ButtonGroup>
          </div>

          <div className="reservations-toolbar__group">
            <ButtonGroup>
              <Button
                onClick={() => {
                  this.props.updateReservationProps([
                    { prop: "isBulkOpen", value: true },
                    { prop: "fromDate", value: null },
                    { prop: "toDate", value: null }
                  ]);
                }}
                color="warning"
              >
                Bulk Schedule Change
              </Button>
            </ButtonGroup>
          </div>
        </div>

        <div className="reservations-card">
          <div className="reservations-card__header">
            <div>
              <div className="reservations-card__eyebrow">Reservation Queue</div>
              <h2 className="reservations-card__title">Reservation Directory</h2>
              <p className="reservations-card__copy">
                Filter by date, occupancy, and efficiency, then jump directly into schedule,
                rooms, members, or deletion actions.
              </p>
            </div>
          </div>

          <div className="reservations-table-shell">
            <ReactTable
              data={reservationRows}
              columns={reservationsDataColumns(
                this.openSchedule,
                this.deleteReservation,
                this.getReservationRooms,
                this.openMembersList
              )}
              defaultPageSize={10}
              filterable
              manual
              pages={last_page != null ? last_page : -1}
              onFetchData={this.paginate}
              loading={isResLoading}
              className="-highlight -striped reservations-table"
            />
          </div>
        </div>

        <RoomModal
          isOpen={isRoomModalOpen}
          updateProps={this.props.updateReservationProps}
          deleteProps={this.props.deleteReservationProps}
          mergeProps={this.props.mergeReservationProps}
          reservationRooms={reservationRooms}
          roomModalReservationId={roomModalReservationId}
          isRoomSaving={isRoomSaving}
          submitRooms={this.submitRooms}
          deleteRoom={this.deleteRoom}
          hotelsLookup={hotelsLookup}
        />
        <MembersModal
          isOpen={isMemberModalOpen}
          updateProps={this.props.updateReservationProps}
          reservation={res}
        />
        <BulkChangeModal
          isOpen={isBulkOpen}
          openChangePage={this.openChangePage}
          fromDate={fromDate}
          toDate={toDate}
          updateProps={this.props.updateReservationProps}
        />
        <DeleteReservationModal
          isOpen={isDeleteReservationModalOpen}
          reservation={deleteReservationRecord}
          isDeleting={!!(deleteReservationRecord && deleteReservationRecord.isDeleting)}
          onCancel={() => {
            this.props.updateReservationProps([
              { prop: "deleteReservationIndex", value: null },
              { prop: "isDeleteReservationModalOpen", value: false }
            ]);
          }}
          onConfirm={this.confirmDeleteReservation}
        />
      </div>
    );
  }
}

const mapStateToProps = ({ reservationReducer, hotelsReducer }) => ({
  reservationReducer,
  hotelsReducer
});

export default connect(
  mapStateToProps,
  actions
)(Reservations);
